export default __webpack_public_path__ + "static/media/CDJRBG.94b03fe6.png";